// extracted by mini-css-extract-plugin
export var wrapper = "ColorBokeh-module--wrapper--8a010";